const downloadWeb = (url: string, filename?: string) => {
  if (!url) {
    return;
  }

  const tempLink = document.createElement('a');

  tempLink.setAttribute('href', url);
  tempLink.download = filename || 'download';
  document.body.appendChild(tempLink);
  tempLink.click();
  tempLink.remove();
};

export { downloadWeb };
